export const quizData = {
  questions: [
    {
      question:
        "Which FRAC Groups do the active ingredients in Postiva belong to?",
      answers: ["11 and 3", "11 and 7", "7 and 3", "12 and 9"],
      correctAnswer: "3",
      explanation: "",
    },
    {
      question: "Which diseases does Postiva control?",
      answers: ["Boytrytis", "Powdery mildew", "Fusarium", "All of the above"],
      correctAnswer: "4",
      explanation: "",
    },
    {
      question:
        "Postiva provides bacterial disease suppression of Pseudomonas spp. and Xanthomonas spp.",
      answers: ["True", "False"],
      correctAnswer: "1",
      explanation: "",
    },
    {
      question: "On what interval can Postiva be applied as a spray? ",
      answers: [
        "7-14-day interval",
        "14-21-day interval",
        "7-10-day interval",
        "None of the above",
      ],
      correctAnswer: "1",
      explanation: "",
    },
    {
      question:
        "Which fungicide can be rotated with Postiva for a comprehensive disease control program? ",
      answers: ["Mural", "Palladium", "Daconil brands", "All of the above"],
      correctAnswer: "4",
      explanation: "",
    },
    {
      question:
        "How many hours after application does ADEPIDYN technology begin to penetrate and spread within the plant tissue to provide systemic disease control?",
      answers: ["48 hours", "24 hours", "12 hours", "72 hours"],
      correctAnswer: "2",
      explanation: "",
    },
    {
      question: "ADEPIDYN technology is a member of a new subclass of ______",
      answers: [
        "demethylation inhibitors (DMIs)",
        "succinate dehydrogenase inhibitors (SDHIs)",
        "Suspo-emulsion fungicides",
        "None of the above",
      ],
      correctAnswer: "2",
      explanation: "",
    },
    {
      question:
        "Difenoconazole offers curative activity by preventing germ tube elongation and mycelial growth, limiting disease development and sporulation.",
      answers: ["True", "False"],
      correctAnswer: "1",
      explanation: "",
    },
    {
      question: "How can Postiva be applied for long-lasting disease control?",
      answers: [
        "Spray & drench",
        "Chemigation",
        "Cold fogging",
        "All the above",
      ],
      correctAnswer: "4",
      explanation: "",
    },
    {
      question: "What crops can Postiva be applied to?",
      answers: [
        "Ornamental crops",
        "Vegetable plants for retail sales",
        "Non-bearing fruit and nut plants",
        "All the above",
      ],
      correctAnswer: "4",
      explanation: "",
    },
  ],
};
